import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchApi } from "@/helpers/h";

function normalizeRows(payload) {
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  if (Array.isArray(payload?.data)) return payload.data;
  return payload?.data ?? payload;
}

const EMPTY_ARRAY = [];

export function useApiList(resourcePath, deps = []) {
  const serializedDeps = JSON.stringify(deps);
  const queryKey = useMemo(
    () => ["apiList", resourcePath, deps],
    [resourcePath, serializedDeps],
  );

  const queryFn = async () => {
    const res = await fetchApi({
      url: resourcePath,
      method: "GET",
    });
    if (res?.data?.success) {
      return normalizeRows(res.data);
    }
    return EMPTY_ARRAY;
  };

  const {
    data: rawData = EMPTY_ARRAY,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey,
    queryFn,
    enabled: !!resourcePath,
  });

  const data = rawData ?? EMPTY_ARRAY;

  return { data, isLoading, isFetching, error: error?.message || null, refetch };
}
